export default function (Vue, parent, _data) {
  var node_end = {
    template: `
    <div class='__config__body'> 
       <el-collapse v-model="activeName" accordion>
        <el-collapse-item title="基本属性" name="1">
          <div>
           <el-form label-width="65px">
            <el-form-item label="唯一标识：" v-show=false>
                <el-input v-model="data['id']" :disabled="true"></el-input>
            </el-form-item>
             <el-form-item label="节点名称：">
                <el-input v-model="data['name']" :disabled="true"></el-input>
            </el-form-item>
         </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>
      </div>
    `,
    props: {
      data: {
        type: Object
      }
    },
    data() {
      return {
        //fields:['id','name'],
        activeName: '1'
      };
    },
    created() {
      if (this.data.name == undefined) {
        this.$set(this.data, 'name', '结束')
      }
    },
    watch: {
      'data.name': function (val, oldVal) {
        var me = this;
        if (val != oldVal) {
          parent.$emit("updateShape", {id: me.data.id, name: val})
        }
      },
      'data.id': function (val, oldVal) {
        if (this.data.name == undefined) {
          delete this.data.name
          this.$set(this.data, 'name', '结束')
        }
      }
    }
  }
  return node_end
}



// WEBPACK FOOTER //
// ./src/modules/index/views/formEdit/flow/flowConfig/node_end.js